import { useEffect } from 'react'
import { OAuth } from '../auth/oauth'

export function LogoutPage() {
  return <Logout />
}

function Logout() {
  useEffect(() => {
    OAuth.logout()
  }, [])

  return <></>
}
